const dateTime = {
  id: 'date-time',
  name: 'Date time',
  Input: null,
  setInitialContent: () => {
    return {};
  },
  formatContent: () => {
    return {};
  },
  valid: () => true,
  snippet: `{
    "type": "date-time",
    "content": {}
}`
};

export default dateTime;
